const service = {

  signup: "users/register",
  emailotpverify: "users/emailotpverify",
  resendCode: "users/resendCode",
  signin: "users/login",
  logout: "users/logout",
  verifyToken: "adminapi/verifyToken",
  adminlogin: "adminapi/login",
  adminlogg: "adminapi/adminlogg",
  verify_otp: "adminapi/verify_otp",

  dashboardcounts: "adminapi/dashboard-counts",
  changeUserAccountStatus: "adminapi/changeUserAccountStatus",
  kycAprove: "adminapi/kycAprove",
  kycReject: "adminapi/kycReject",
  getdepositinfo: "adminapi/getdepositinfo",
  verifyDeposit: "adminapi/verifyDeposit",
  addBank: "adminapi/editadmin",
  addedBanks: "adminapi/alladmins",

  getKyclist: "adminapi/getKyclist",

  rewardManagement: "adminapi/reward-settings",
  referralrewardManagement: "adminapi/referral-reward-settings",
  getRewardManagement: "adminapi/get-reward",

  airdropManagement: "adminapi/airdrop-settings",
  getAirdropManagement: "adminapi/get-airdrop",

  activatedUserList: "adminapi/activatedUserList",

  tradepair_view: "adminapi/tradepair/view",
  changetradeStatus: "adminapi/tradepair/changestatus",
  changeliqudityStatus: "adminapi/tradepair/changeliqstatus",
  tradecurrency: "adminapi/tradepair/currency",
  getTradepairOne: "adminapi/tradepair/getTradepairOne",
  addTradePair: "adminapi/tradepair/addTradePair",
  deletetradepair: "adminapi/tradepair/deletetradepair",
  mmbotStatusUpdate: "adminapi/bot_update",


  getAdminTfaDetials: "adminapi/getQRcode",
  adminChangeTfaStatus: "adminapi/changeTfaStatus",
  adminChangePassword: "adminapi/changePassword",

  userbalance: "adminapi/userbalance",
  useraddress: "adminapi/useraddress",
  get_all_user_deposit: "withdraw/get_all_user_deposit",
  get_all_user_withdraw: "withdraw/get_all_user_withdraw",
  admin_withdraw_approve: "withdraw/admin_withdraw_approve",

  changeEmail: "adminapi/changeEmail",
  Addbalance: "adminapi/Addbalance",

  cms_update: "adminapi/cms_update",
  allCurrencyListCrypto: "adminapi/allCurrencyListCrypto",
  viewOneCurrency: "adminapi/viewOneCurrency",
  getStaking: "adminapi/getStaking",

  getprofit: "adminapi/getprofit",
  cms_list: "adminapi/cms_list",
  currencyAddUpdate: "adminapi/currencyAddUpdate",
  updateStakingFlexible: "adminapi/updateStakingFlexible",

  deletecurrency: "adminapi/deletecurrency",

  cms_get: "adminapi/cms_get",
  mailtemplate_list: "adminapi/mailtemplate_list",
  mailtemplate_update: "adminapi/mailtemplate_update",
  mailtemplate_get: "adminapi/mailtemplate_get",
  deletetemplate: "adminapi/deletetemplate",
  deletecmsdetail: "adminapi/deletecmsdetail",
  getAdminProfile: "adminapi/admindetails",
  get_sitedata: "adminapi/get_sitedata",
  update_settings: "adminapi/update_settings",
  updateProfile: "adminapi/updateProfile",
  updateTfa: "adminapi/updateTfa",
  checkPassword: "adminapi/check_password",

  sitesetting: "adminapi/addsitesettings",
  getSitedata: "adminapi/getsitesettings",

  support_category_list: "adminapi/support_category_list",
  support_category_get: "adminapi/support_category_get",
  support_category_update: "adminapi/support_category_update",
  support_category_delete: "adminapi/support_category_delete",
  support_save: "adminapi/support_save",
  support_list: "adminapi/support_list",
  support_view: "adminapi/support_view",
  ticket_close: "adminapi/ticket_close",
  forgotemailotp: "adminapi/forgotemailotp",
  forgototpverify: "adminapi/forgototpverify",
  resetpassword: "adminapi/forgotpassword",
  resendemailotp: "adminapi/resendemailotp",

  getActiveOrders: "adminapi/getActiveOrders",
  getOrdersHistory: "adminapi/getTradeHistory",
  getCancelOrdersHistory: "adminapi/getCancelOrders",
  get_all_user_swap: "adminapi/get_all_user_swap",
  getProfit: "adminapi/getprofit",
  getinternalTransfer: "adminapi/getTransferHistory",
  getP2Porders: "adminapi/getP2POrdersHistory",
  getP2PconfirmOrders: "adminapi/getP2PConfirmOrdersHistory",
  getP2Pdispute: "adminapi/getP2PDisputeHistory",
  getdisputedetail: "adminapi/getDisputeDetail",
  changeActivedispute: "adminapi/changeActivedispute",
  changefreezedispute: "adminapi/changefreezedispute",
  getadminProfitDetails: "adminapi/getProfitDetails",
  downloadProfits: "adminapi/downloadProfits",

  //wallet
  wallet_login: "adminapi/wallet_login",
  walletCurrenList: "adminapi/fund_wallet_list",
  generateAdminaddress: "address/generateAdminAddress",
  transaction: "adminapi/get_deposit_list",
  fieldValidate: "withdraw/fieldvalidateAdmin",
  withdrawProcess: "withdraw/processAdmin",
  getBalanceBlock: "adminapi/getBalance",
  getWalletTransaction: "adminapi/adminwallet_transactions",
  cancel_p2pOrder: "adminapi/cancel_confirm_order",
  confirm_p2pOrder: "adminapi/release_coin",
  get_user: "adminapi/get_user",


  //Otc
  getOtcSettings: "adminapi/getOtcSettings",
  editOtcSettings: "adminapi/editOtcSettings",
  createOtcSettings: "adminapi/createOtcSettings",
  getfiatWithdraw: "adminapi/getwithdrawinfo",
  verifyWithdraw: "adminapi/verifyWithdraw",


  //launchpad

  getAllLaunchTokensList: "launchpad/getAllLaunchTokensList",
  viewOneToken: "launchpad/viewOneToken",
  approveToken: "launchpad/approveToken",
  rejectToken: "launchpad/rejectToken",
  deleteToken: "launchpad/deleteToken",


//staking

stakeAdd:"staking/stakeAdd",
getStake:"staking/getStake",
stakeUpdate:"staking/stakeUpdate",
deleteStake:"staking/deleteStake",
getStakePlansHistoryAdmin:"staking/getStakePlansHistoryAdmin",
updatestakesetting:"staking/updatestakesetting",
getStakesettings:"staking/getStakesettings",


getfiatdeposit:"adminapi/getfiatdeposit",


  getAdminChat:"adminapi/getAdminChat",
  submitChatAdmin:"adminapi/submitChatAdmin",
  resolved:"adminapi/resolved",
  adminReleaseCrypto:"adminapi/adminReleaseCrypto",
  getAllstakingHistory:"adminapi/getAllstakingHistory"

};

export default service;
